import React, {lazy, Suspense, useContext} from "react";
import {
  StyledSectionBody,
  StyledSectionContainer,
  StyledSectionDescription,
  StyledSectionTitle
} from "./ScrollSection-styled";
import PacType from "../PacReport/PacType";
// import Location from "../Location/Location";
// import VehiclePracticability from "../PacReport/VehiclePracticability";
// import Describe from "../PacReport/Describe";
// import ReportContacts from "../ReportContacts/ReportContacts";
// import StorageSpace from "../WarehouseReport/StorageSpace";
// import CommunityShare from "../WarehouseReport/CommunityShare";
// import ReportFinal from "../ReportFinal";
import {ConfigContext} from "../../../../utils/ConfigContext";

const Location = lazy(() => import('../Location/Location'));
// const PacType = lazy(() => import('../PacReport/PacType'));
const VehiclePracticability = lazy(() => import('../PacReport/VehiclePracticability'));
const Describe = lazy(() => import('../PacReport/Describe'));
const ReportContacts = lazy(() => import('../ReportContacts/ReportContacts'));
const StorageSpace = lazy(() => import('../WarehouseReport/StorageSpace'));
const CommunityShare = lazy(() => import('../WarehouseReport/CommunityShare'));
const ReportFinal = lazy(() => import('../ReportFinal'));


const ScrollSection = ({index, item, children, goNext, form, setForm, resetReport, layer,t, page}) => {
  const {config} = useContext(ConfigContext);
  const render = () =>{
    
    switch (item?.component) {
      case 'pactype':{
        return <PacType form={form} setForm={setForm} goNext={goNext} config={config} t={t} />
      }
      case 'location':{
        return <Suspense><Location form={form} setForm={setForm} config={config} t={t} /></Suspense>
      }
      case 'vehiclePracticability':{
        return <Suspense><VehiclePracticability form={form} setForm={setForm} goNext={goNext} layer={layer} config={config} t={t} /></Suspense>
      }
      case 'describe': {
        return <Suspense><Describe config={config} form={form} setForm={setForm} t={t} /></Suspense>
      }
      case 'contacts':{
        return <Suspense><ReportContacts t={t} /></Suspense>
      }
      case 'storagespace':{
        return <Suspense><StorageSpace layer={layer} form={form} setForm={setForm} goNext={goNext} config={config} t={t}/></Suspense>
      }
      case 'communityshare':{
        return <Suspense><CommunityShare layer={layer} form={form} setForm={setForm} goNext={goNext} config={config} t={t} /></Suspense>
      }
      case 'more': {
        return <Suspense><ReportFinal resetReport={resetReport} t={t}/></Suspense>
      }
      default:{
        return  <div />
      }
    }
  }
  
  return (
    <StyledSectionContainer
      id={`scrollSection-${index}`}
      name={`scrollSection-${index}`}
    >
      <div
        style={{
          margin:'auto',
          width:'100%',
          overflow:'hidden',
          height:'100%',
          display:'flex',
          flexDirection:'column',
          justifyContent:'center'
        }}>
        {
          item?.title && <div style={{padding:'0px 24px'}}>
            <StyledSectionTitle>{item.title}{item?.required?.length > 0 && "*"}</StyledSectionTitle>
          </div>
        }
        <StyledSectionBody style={{overflow:'auto', padding:'5px 24px'}}>
          {item?.description && <StyledSectionDescription>{item.description}</StyledSectionDescription>}
          {children ?? render()}
        </StyledSectionBody>
      </div>
    </StyledSectionContainer>
  );
};

export default ScrollSection;
